import { ServiceIcon2 } from '@/widgets/Header/ui/assets/ServiceIcon2'
import { ServiceIcon4 } from '@/widgets/Header/ui/assets/ServiceIcon4'
import { ServiceIcon5 } from '@/widgets/Header/ui/assets/ServiceIcon5'
import { ServiceIcon6 } from '@/widgets/Header/ui/assets/ServiceIcon6'

// import serviceIcon1 from './assets/upgradeIcon.svg'

export const loyaltyMenuItems = [
	// {
	// 	code: `sales`,
	// 	title: `Акции`,
	// 	link: `/sales/`,
	// 	accent: true,
	// 	Icon: SaleIcon
	// },
	{
		code: 'new',
		title: 'Новинки',
		link: '/new/'
	},
	{
		code: `discount`,
		title: `Уценка`,
		link: `/discount/`
	}
	// {
	// 	code: `markdown`,
	// 	title: `Уценка`,
	// 	link: `/markdown`
	// }
]

export const otherMenuItems = [
	{
		title: `Услуги`,
		link: `/services/`,
		code: `services`,
		// Icon: ServiceDots,
		items: [
			{
				title: `Обмен в Трейд-ин`,
				link: `/services/trade-in/`,
				code: `tradein`,
				description: `Меняйтесь с легкостью. Сдайте свое старое устройство и получите выгоду на новое`,
				Icon: ServiceIcon2
			},
			{
				title: `Карта преимуществ iPort+`,
				link: `/services/plus/`,
				code: `iportplus`,
				description: `Изучай новое и открывай больше возможностей с экспертами iPort`,
				Icon: ServiceIcon4
			},
			{
				title: `Страхование`,
				link: `/services/insurance/`,
				code: `insurance`,
				description: `Защити свое устройство от случайных повреждений`,
				Icon: ServiceIcon5
			},
			{
				title: `Рассрочка и кредит`,
				link: `/services/credit/`,
				code: `credit`,
				description: `Изучай новое и открывай больше возможностей с экспертами iPort`,
				Icon: ServiceIcon6
			}
			// Archived
			// {
			// 	title: `iPort Upgrade`,
			// 	link: `/services/iport-upgrade/`,
			// 	code: `upgrade`,
			// 	description: `с экспертами iPort`,
			// 	icon: serviceIcon1.id
			// }
		]
	}
]
